module.exports = __webpack_public_path__ + "img/Marca9.9adef070.jpg";